var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C17.0752 0 22 4.92488 22 11C22 17.0752 17.0752 22 11 22C4.92487 22 0 17.0752 0 11C0 4.92488 4.92487 0 11 0ZM11 1.64975C5.836 1.64975 1.64975 5.83601 1.64975 11C1.64975 16.1641 5.836 20.3503 11 20.3503C16.1641 20.3503 20.3503 16.1641 20.3503 11C20.3503 5.83601 16.1641 1.64975 11 1.64975ZM10.996 9.3492C11.4136 9.34898 11.7589 9.65902 11.8138 10.0616L11.8214 10.1735L11.8253 16.2243C11.8257 16.6799 11.4566 17.0494 11.001 17.0498C10.5834 17.05 10.2381 16.74 10.1832 16.3374L10.1756 16.2254L10.1716 10.1746C10.1714 9.71907 10.5404 9.34953 10.996 9.3492ZM11.0005 5.50225C11.6071 5.50225 12.0989 5.99401 12.0989 6.60061C12.0989 7.20722 11.6071 7.69898 11.0005 7.69898C10.3939 7.69898 9.90218 7.20722 9.90218 6.60061C9.90218 5.99401 10.3939 5.50225 11.0005 5.50225Z",
    fill: "#A19F9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.79d3317ba3a59c455c96343779dbe716.svg";
export { ForwardRef as ReactComponent };